/// <reference path="waitList.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WaitList {

    class WaitListNoteModalController {
        static $inject = ["placeholder", "originalNote", "meevo.components.modal.ModalService"];

   
        public placeholder: string;
        public note: string;
        public originalNote: any;
    
        constructor(placeholder: string, originalNote: string, protected modalService: Meevo.Components.Modal.IModalService) {
            this.placeholder = placeholder;

            // Original Note
            this.originalNote = originalNote;

            // New Note being written 
            this.note = originalNote;
        }

        saveWaitListNotes() {
            this.modalService.hideWithResponse(this.note);
        }

        closeAndErase = () => {
            this.modalService.hideWithResponse(this.originalNote);
        }


    }



    angular.module("meevo.plugins.waitList")
        .controller("meevo.plugins.waitList.WaitListNoteModalController", WaitListNoteModalController);
}
